import type { ReactNode } from 'react'
import type { UserRole } from '@assessments/shared'
import { useSession } from '../../features/auth/SessionContext.js'
import { PermissionDenied } from './PermissionDenied.js'

interface RequireRoleProps {
  roles: UserRole[]
  children: ReactNode
}

export function RequireRole({ roles, children }: RequireRoleProps) {
  const { session, loading } = useSession()

  if (loading) return null

  if (!session || !session.user.roles.some((r) => roles.includes(r as UserRole))) {
    return <PermissionDenied />
  }

  return <>{children}</>
}
